module.exports = __webpack_public_path__ + "img/nb-4.68eec028.png";